import { render, staticRenderFns } from "./BiChartEmpty.vue?vue&type=template&id=90bae498&scoped=true"
import script from "./BiChartEmpty.vue?vue&type=script&lang=js"
export * from "./BiChartEmpty.vue?vue&type=script&lang=js"
import style0 from "./BiChartEmpty.vue?vue&type=style&index=0&id=90bae498&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bae498",
  null
  
)

export default component.exports